import {Color, Size} from '#theme';

/**
 * The colors that are not allowed to be used for fallback avatar
 */
export const EXCLUDED_AVATAR_COLORS: Color[] = [
  Color.Background,
  Color.BackgroundAccent,
  Color.BackgroundAlt,
  Color.Body,
  Color.BodyLight,
  Color.BodyAccent,
  Color.Heading,
  Color.HeadingAccent,
];
/**
 * The fallback name for the avatar when the user doesn't have a name
 */
export const DEFAULT_NAME = 'U';
/**
 * The default size for the avatar
 */
export const DEFAULT_SIZE = Size.Sixteen;
/**
 * The default color for the avatar
 */
export const DEFAULT_COLOR = Color.Secondary;
/**
 * The default font size for fallback initials
 */
export const DEFAULT_FONT_SIZE = '66cqw';
/**
 * The default icon size for the avatar
 */
export const DEFAULT_ICON_SIZE = '75cqw';
